import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function getIncomingUserInvitations() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserInvitation/GetIncomingUserInvitations',
  });
  return data;
}

async function acceptUserInvitation({ invitationId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserInvitation/AcceptUserInvitation',
    data: sanitizePostData({ invitationId }),
  });
  return data;
}

async function revokeUserInvitation({ invitationId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserInvitation/RevokeUserInvitation',
    data: sanitizePostData({ invitationId }),
  });
  return data;
}

export {
  getIncomingUserInvitations,
  acceptUserInvitation,
  revokeUserInvitation,
};
